var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", { class: _vm.pagination_class }, [
    _c("div", { staticClass: "align-self-center" }, [
      _c(
        "div",
        {
          staticClass: "page-paginate--rows-select d-none d-md-inline-block",
          class: _vm.classes.select.class
        },
        [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selectedRowsPerPage,
                  expression: "selectedRowsPerPage"
                }
              ],
              staticClass: "no-bg d-inline-block",
              class: _vm.classes.select.element,
              attrs: { id: _vm.page_id },
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.selectedRowsPerPage = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                }
              }
            },
            _vm._l(_vm.select_options, function(select_option) {
              return _c(
                "option",
                {
                  class: _vm.classes.select.element_option,
                  domProps: { value: select_option }
                },
                [_vm._v(_vm._s(select_option) + "\n                ")]
              )
            })
          ),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "mx-1 my-0 d-inline-block",
              class: _vm.classes.select.label,
              attrs: { for: _vm.page_id }
            },
            [_vm._v("Results")]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page-paginate--index", class: _vm.classes.index },
        [
          _c("span", { staticClass: "align-middle" }, [
            _vm._v(
              _vm._s(_vm.page_start + 1) +
                " - " +
                _vm._s(
                  _vm.page_start + _vm.page_limit > _vm.pages_length
                    ? _vm.pages_length
                    : parseInt(_vm.page_start + _vm.page_limit)
                ) +
                " of " +
                _vm._s(_vm.pages_length)
            )
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "page-paginate--buttons",
        class: _vm.classes.button.class
      },
      [
        _c(
          "div",
          { staticClass: "d-flex justify-content-end align-content-center" },
          [
            _c(
              "div",
              {
                staticClass: " btn btn-primary btn-sm mr-1 m-0",
                on: {
                  click: function($event) {
                    _vm.movePage(false)
                  }
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "prev cursor--pointer",
                    class: _vm.setButtonClasses(false, "previous")
                  },
                  [_c("i", { staticClass: "fa fa-chevron-left" })]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: " btn btn-primary btn-sm m-0",
                on: {
                  click: function($event) {
                    _vm.movePage(true)
                  }
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "next cursor--pointer",
                    class: _vm.setButtonClasses(true, "next")
                  },
                  [_c("i", { staticClass: "fa fa-chevron-right" })]
                )
              ]
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ac265be", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ac265be","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./app/Shared/Resources/Assets/js/components/Pagination.vue
// module id = 647
// module chunks = 0